var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.83,
    height: 25.831,
    viewBox: "0 0 25.83 25.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M25.5,22.325l-4.908-4.908a11.252,11.252,0,1,0-3.176,3.176L22.324,25.5a1.122,1.122,0,0,0,1.588,0L25.5,23.913A1.122,1.122,0,0,0,25.5,22.325ZM2.246,11.231a8.984,8.984,0,1,1,8.984,8.984A8.995,8.995,0,0,1,2.246,11.231Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.e5830b02feecf1ec1b42dbb9d98d6a06.svg";
export { ForwardRef as ReactComponent };